type LogProps<T> = {
  error?: Error;
  /** log message */
  message?: string;
  /** output any object to console */
  output?: T;
  /** if outputs message in the console */
  outputsToConsole?: boolean;
};

export class LogUtil {
  static info = <T>(logProps: LogProps<T>): void => {
    // eslint-disable-next-line no-console
    if (logProps.outputsToConsole !== false) console.log(logProps.message, logProps.output);
  };

  static warn = <T>(logProps: LogProps<T>): void => {
    // eslint-disable-next-line no-console
    if (logProps.outputsToConsole !== false) console.warn(logProps.message, logProps.output);
  };

  static error = <T>(logProps: LogProps<T>): void => {
    // eslint-disable-next-line no-console
    if (logProps.outputsToConsole !== false) console.error(logProps.message, logProps.output);
  };
}
